import * as React from "react";
import { FormattedMessage } from "react-intl";
import Icon from "../../icons";
import SolidButton from "../solidButton";

import {
  BLUE700,
  GREY500,
  GREY1000,
  WHITE100,
} from "@vingle/wtf-sdk/constants/palette";
const styles = require("./followButton.scss");

interface IFollowButtonProps {
  isFollowing: boolean;
  text?: React.ReactNode;
  onFollowClick: () => void;
}

const WRAPPER_STYLE: React.CSSProperties = {
  display: "block",
  textAlign: "center",
  width: 148,
  height: 40,
  maxWidth: "auto",
};

const BUTTON_STYLE = {
  display: "inline-block",
  verticalAlign: "top",
  lineHeight: "1.71",
  width: "100%",
  height: "100%",
  fontSize: "14px",
};

const RawFollowButton = ({
  isFollowing,
  text = (
    <FormattedMessage tagName="span" id="search_page.interest.follow_text" />
  ),
  onFollowClick,
}: IFollowButtonProps) => {
  if (isFollowing) {
    return (
      <SolidButton
        onClick={onFollowClick}
        buttonText={
          <span className={styles.unFollowButton}>
            <Icon icon="ADDED_SMALL" />
            {text}
          </span>
        }
        wrapperStyle={WRAPPER_STYLE}
        buttonStyle={{
          ...BUTTON_STYLE,
          border: `solid 1px ${GREY500}`,
          color: GREY1000,
        }}
      />
    );
  } else {
    return (
      <SolidButton
        onClick={onFollowClick}
        buttonText={
          <span className={styles.followButton}>
            <Icon icon="ADD_SMALL" />
            {text}
          </span>
        }
        wrapperStyle={WRAPPER_STYLE}
        buttonStyle={{
          ...BUTTON_STYLE,
          border: `solid 1px ${BLUE700}`,
          backgroundColor: BLUE700,
          color: WHITE100,
          fontWeight: 300,
        }}
      />
    );
  }
};

export const FollowButton = RawFollowButton;
